/* eslint-disable @typescript-eslint/no-non-null-assertion,react/jsx-props-no-spreading,react-hooks/exhaustive-deps */
import { FC, ReactNode, useContext, useEffect, useRef, useState } from 'react';

import { Button, Form, Input, Space, Tooltip } from 'antd';
import { EditableContext } from 'components/CustomTable';
import { SaveOutlined } from '@ant-design/icons';
import asyncErrorHandler from 'utils/asyncErrorHandler';

interface EditableCellProps {
  title: ReactNode;
  editable: boolean;
  children?: ReactNode;
  dataIndex: any;
  record: any;
  handleSave: (record: any) => void;
  editComponent: any;
  onToggleEdit: any;
  onSaveRecord: any;
}

const EditableCell: FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  editComponent,
  onToggleEdit,
  onSaveRecord,
  ...restProps
}) => {
  const [activeCell, setActiveCell] = useState<null | string>(null);
  const inputRef = useRef<any>(null);
  const form = useContext(EditableContext)!;

  const editing = `${record?.uuid} ${dataIndex}` === activeCell;

  useEffect(() => {
    if (editing) {
      inputRef?.current?.focus();
      form?.setFieldsValue({ [dataIndex]: record[dataIndex] ? record[dataIndex] : undefined });
      if (onToggleEdit) {
        onToggleEdit(record, form);
      }
    }
  }, [editing]);

  const cancel = () => {
    setActiveCell(null);
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      if (Object.keys(values)?.length === 0) {
        return;
      }
      if (onSaveRecord) {
        onSaveRecord(handleSave, record, values);
      } else {
        handleSave({ ...record, ...values });
      }
      cancel();
    } catch (err) {
      asyncErrorHandler(err);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24, minHeight: 10 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Space>
          {editComponent ? (
            editComponent(record, save, form, cancel)
          ) : (
            <Form.Item style={{ margin: 0 }} name={dataIndex}>
              <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
          )}
          <Tooltip title="Save">
            <Button type="text" icon={<SaveOutlined className="primary" />} onClick={save} />
          </Tooltip>
        </Space>
      </div>
    ) : (
      <div className="editable-cell-value-wrap" style={{ paddingRight: 24, minHeight: 10 }}>
        {children}
      </div>
    );
  }

  return (
    <td
      onClick={() => {
        setActiveCell(`${record?.uuid} ${dataIndex}`);
      }}
      {...restProps}
    >
      {childNode}
    </td>
  );
};

export default EditableCell;
